import styled, { css } from 'styled-components';
import { Translator } from 'ggApp/modules/translator';

export const CartPreviewWrap = styled.div`
    padding: 24px 24px 16px 24px;
    display: flex;
    flex-direction: column;
`;

export const CartPreviewTitle = styled(Translator)`
    ${(props) => css(props.theme.typography.SmallCapsHeadline)}
    margin-bottom: 16px;
`;

export const ThumbnailsWrap = styled.div`
    display: flex;
`;

export const ProductThumbnail = styled.div`
    background-color: ${({ theme }) => theme.colors.Background};
    border: 2px solid ${({ theme }) => theme.colors['Level 1']};
    border-radius: 8px;
    width: 52px;
    min-width: 52px;
    height: 52px;
    margin-right: 8px;
    background-image: ${(props) =>
        props.productThumbnail ? `url(${props.productThumbnail})` : ''};
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    background-origin: content-box;
    padding: 8px;
    ${(props) => props.theme.typography.SuperTinyHeadline};
    color: ${({ theme }) => theme.colors['Level 4']};
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const CartPreviewText = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 8px;
    justify-content: center;
`;

export const Text = styled.div`
    ${(props) => css(props.theme.typography.TinyParagraph)}
    color: ${({ theme }) => theme.colors['Level 5']};
`;

export const Price = styled.div`
    ${(props) => css(props.theme.typography.SuperTinyHeadline)}
`;

export const ProductThumbWrapper = styled.div`
    position: relative;
`;

export const QtyBadge = styled.div`
    position: absolute;
    background-color: ${({ theme }) => theme.colors.Color2};
    top: -5px;
    right: 0px;
    min-width: 20px;
    max-width: 100%;
    height: 20px;
    border-radius: 12px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1px;
    overflow: hidden;
`;

export const QtyText = styled.span`
    ${(props) => css(props.theme.typography.SmallCapsHeadline)};
    color: #fff;
    letter-spacing: 0 !important;
`;
